type WorkspaceStorageInputOwner = {
  actorId: string;
  actorType: 'user' | 'visitor';
};

export function readWorkspaceStorageInputOwner(
  inputUrl: string
): WorkspaceStorageInputOwner | null {
  let pathname: string;
  try {
    pathname = new URL(inputUrl, 'https://workspace.invalid').pathname;
  } catch {
    return null;
  }

  const parts = pathname.split('/').filter(Boolean);
  const aiIndex = parts.findIndex((part) => part === 'ai');
  if (
    aiIndex < 0 ||
    (parts[aiIndex + 1] !== 'input' && parts[aiIndex + 1] !== 'output') ||
    (parts[aiIndex + 2] !== 'free' && parts[aiIndex + 2] !== 'premium')
  ) {
    return null;
  }

  const actorType = parts[aiIndex + 3];
  const actorId = parts[aiIndex + 4];
  if ((actorType !== 'user' && actorType !== 'visitor') || !actorId) {
    return null;
  }

  return { actorId, actorType };
}

export function shouldReuploadWorkspaceStorageInput(params: {
  inputUrl: string | null;
  localFile: File | null;
  userId: string | null;
}) {
  if (!params.inputUrl || !params.localFile) {
    return false;
  }

  const owner = readWorkspaceStorageInputOwner(params.inputUrl);
  if (!owner) {
    return false;
  }

  if (params.userId) {
    return owner.actorType !== 'user' || owner.actorId !== params.userId;
  }

  return owner.actorType !== 'visitor';
}

export function requiresWorkspaceStorageInputUpload(params: {
  inputUrl: string | null;
  localFile: File | null;
  userId: string | null;
}) {
  if (!params.localFile) {
    return false;
  }

  return !params.inputUrl || shouldReuploadWorkspaceStorageInput(params);
}
